import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Dialog, InputText, VSpacer, HSpacer, Button } from 'sm-react-components';

import * as requests from '../../infrastructure/requests';
import { Tabs, Tab, Grid, Typography } from '@material-ui/core';
import Quota from '../views/Quota';

const styles = (theme) => ({
    tabsRoot: {
        borderBottom: '1px solid #e8e8e8',
        paddingLeft: '24px',
        paddingRight: '24px'
    },
    tabsIndicator: {
        backgroundColor: theme.palette.primary.main,
    }
});

class UserModal extends Component {
    state = {
        value: 0,
        loading: false,
        user: undefined,
        error: undefined
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.userId !== this.props.userId) {
            this.load();
        }
    }

    load = async () => {
        try {
            const { userId } = this.props;
            this.setState({ loading: true, error: undefined });
            const user = await requests.getUserDetails(userId);
            const quota = await requests.getUserQuota(userId);
            this.setState({ loading: false, user, quota });
        }
        catch (exception) {
            this.setState({ loading: false, error: exception.message });
        }
    }
    handleChange = (event, val) => {
        this.setState({ ...this.state, value: val });
    }

    handleDeleteUser = async (userId) => {
        const response = await requests.softDeleteUser(userId);
        if (response.message === 'User deleted succesfully') {
            window.location.reload();
        }
    }

    render() {
        const { loading, user, error, value } = this.state;
        const { classes, open, userId, onClose, rootUser } = this.props;
        return (
            <Dialog
                open={open}
                loading={loading}
                title="Edit user"
                modal={true}
                error={error}
                onClose={onClose}
                showCancel={true}
                closeText={'Close'}
            >
                {!loading && user &&
                    <Fragment>
                        <Tabs value={value}
                            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                            onChange={this.handleChange}>
                            <Tab label="User details"></Tab>
                            <Tab label="Services"></Tab>
                            {/* <Tab label="Billing information"></Tab> */}
                        </Tabs>
                        <VSpacer small />
                        {value === 0 &&
                            <Grid container style={{ padding: '32px' }}>
                                <Grid item>
                                    <InputText disabled value={user.firstName} label="User name" />
                                </Grid>
                                <HSpacer large />
                                <HSpacer large />
                                <Grid item>
                                    <InputText disabled value={user.lastName} label="Last name" />
                                </Grid>
                                <Grid item>
                                    <InputText disabled value={user.email} label="Email" />
                                </Grid>
                                <HSpacer large />
                                <HSpacer large />
                                <Grid item>
                                    <InputText disabled value={user.phone} label="Phone" />
                                </Grid>
                                <Grid item>
                                    <InputText disabled value={user.company} label="Company" />
                                </Grid>
                            </Grid>
                        }
                        <VSpacer small />
                        {value === 1 &&
                            <div style={{ marginRight: '32px', marginLeft: '32px' }}><Quota userId={userId} /></div>
                        }
                        <VSpacer small />
                        {value === 0 && userId !== rootUser.id && rootUser.roles.includes('root') &&
                            <div style={{ marginRight: '32px', marginLeft: '32px', padding: '8px', border: '2px solid #FF2825', borderRadius: '8px' }}>
                                <Typography variant="h5" style={{ paddingBottom: '8px' }}>Danger actions</Typography>
                                <Grid container style={{ padding: '8px' }}>
                                    <Grid lg={8}>
                                        <Typography style={{ padding: '8px 0px' }}>You are switching off the account of the user. He won’t be able to login again. </Typography>
                                    </Grid>
                                    <Grid lg={4}>
                                        <Button style={{ float: 'right', height: '100%' }} color='primary' onClick={() => this.handleDeleteUser(userId)}>Delete user</Button>
                                    </Grid>
                                </Grid>

                            </div>
                        }
                    </Fragment>
                }
            </Dialog>
        );
    }
}

export default withStyles(styles)(UserModal);